<template>
  <div class="container">
    <div class="rowView thanks">
      <h3>{{ sendResponse }}</h3>
      <p>
{{ sendResponseText }}
      </p>
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name:'phaseThanks',
  data() {
    return {
      result:"OK",
      sendResponse:"",
      sendResponseText:"",
    }
  },
  props: {
    fields: {
      name:{
        type:String,
        required: true,
      }, 
      company:{
        type:String
      }, 
      department:{
        type:String
      },
      mail:{
        type:String,
        required: true,
      }, 
      telephone:{
        type:String
      }, 
      inquirys:{
        type:Object,
        required: true,
      }, 
      freeText:{
        type:String,
        required: true,
      },
		},
  },
  mounted() {
    this.submit()
  },
  methods:{
    toInput() {
      this.$emit('changePhase', 'form-input')
    },
    toConfirm() {
      this.$emit('changePhase', 'form-confirm')
    },
    toThanks() {
      this.$emit('changePhase', 'form-thanks')
    },

/*メール送信部分*/
    submit: async function(){
        const result = await this.send()
        this.result = result

        switch(result) {
        case 'OK':
          this.sendResponse = "お問い合わせありがとうございます"
          this.sendResponseText = "お問い合わせいただいた内容については、3営業日内に返信いたします。"
          break
        case 'NG':
          this.sendResponse = "送信エラーが発生しました（エラー：xxxxxxx）"
          this.sendResponseText = "送信時に何らかの要因により正常にメールが送られませんでした。"
          break
        default:
          this.sendResponse = result
          this.sendResponseText = "送信時に何らかの要因により正常にメールが送られませんでした。\n\nしばらくたってから再送信いただくか、直接メールでお問い合わせをお願いいたします。"
        }
    },
    send: async function(){
//console.log(this.axios.defaults.baseURL)
        const url = 'https://toyoshimaseimitsu.co.jp/cgi/mail.cgi'
/*
        const url = 'https://toyoshimaseimitsu.co.jp/cgi/test.cgi'
*/
        const params = {
            'name': this.fields.name,
            'company': this.fields.company,
            'department': this.fields.department,
            'mail': this.fields.mail,
            'telephone': this.fields.telephone,
            'inquirys': this.fields.inquirys,
            'freeText': this.fields.freeText,
        }
        return await axios
					.post(url, params)
					.then(function(res){
							return res.data
					})
					.catch(function(error){
							return error
					})
    },
  }
}
</script>

<style>
</style>
